export type Voice = {
  quote: string
  author: string
  source: string
}

/**
 * Vacío a propósito (DPS47): el VOC de la ficha es flaco y casi todo viene de
 * fuentes que nombran la marca registrada o de testimonios de otro vendedor.
 * Con el array vacío la sección no se muestra. Solo cargar frases reales,
 * textuales y con fuente.
 */
export const leaderVoices: Voice[] = []

export const moreLeaderVoices: Voice[] = []
